const SectionContacts = Class(
	/**
	 * @lends {SectionContacts}
	 */
	{
		bodyClass: 'small-nav',
		menuItem: 'contacts',

		__construct: function(){
			this.node = mkE({
				tag: 'div',
				id: 'contact-us'
			});
		},

		draw: function(){
			this.node.append(this.layout.ct());
			mkE({
				tag: 'div',
				className: 'container contact-info',
				els: [
					{
						tag: 'h1',
						text: D.Lang.get('contacts.title')
					},
					{
						tag: 'p',
						text: D.Lang.get('contacts.text')
					},
					{
						tag: 'div',
						className: 'contact-items',
						els: [
							{
								tag: 'div',
								className: 'item item-email',
								els: [
									{
										tag: 'div',
										className: 'title',
										text: D.Lang.get('contacts.email.title')
									},
									{
										tag: 'div',
										className: 'text',
										text: D.Lang.get('contacts.email.text')
									},
									{
										tag: 'div',
										className: 'url',
										els: [
											{
												tag: 'a',
												href: D.url('/how-to-play'),
												text: D.Lang.get('contacts.email.url')
											}
										]
									}
								]
							},
							{
								tag: 'div',
								className: 'item item-phone',
								els: [
									{
										tag: 'div',
										className: 'title',
										text: D.Lang.get('contacts.phone.title')
									},
									{
										tag: 'div',
										className: 'text',
										text: D.Lang.get('contacts.phone.text')
									},
									{
										tag: 'div',
										className: 'text2',
										text: D.Lang.get('contacts.phone.text2')
									}
								]
							},
							{
								tag: 'div',
								className: 'item item-address',
								els: [
									{
										tag: 'div',
										className: 'title',
										text: D.Lang.get('contacts.address.title')
									},
									{
										tag: 'div',
										className: 'text',
										text: D.Lang.get('contacts.address.text')
									},
									{
										tag: 'div',
										className: 'url',
										els: [
											{
												tag: 'a',
												href: 'https://goo.gl/maps/EKP5XwjZiFQ3QcAm8',
												text: D.Lang.get('contacts.address.url'),
												target: '_blank'
											}
										]
									}
								]
							},
							{
								tag: 'div',
								className: 'item item-address',
								els: [
									{
										tag: 'div',
										className: 'title',
										text: D.Lang.get('contacts.company.title')
									},
									{
										tag: 'div',
										className: 'text',
										text: D.Lang.get('contacts.company.text')
									}/*,
									{
										tag: 'div',
										className: 'text2',
										text: D.Lang.get('contacts.company.text2')
									}*/
								]
							}
						]
					}
				]
			}).append(this.node);
			mkE({
				tag: 'div',
				className: 'map-form',
				els: [
					{
						tag: 'div',
						className: 'map-container',
						els: [
							this._mapNode = mkE({
								tag: 'div',
								className: 'map'
							})
						]
					},
					{
						tag: 'div',
						className: 'container',
						els: [
							this._socialsForm = mkE({
								tag: 'div',
								className: 'socials-form'
							})
						]
					}
				]
			}).append(this.node);
			T.SocialIcons().append(this._socialsForm);
			new SectionContacts.Form().append(this._socialsForm);
			this._drawMap();
			this.ready();
		},

		_drawMap: function(){
			D.addJS('https://maps.googleapis.com/maps/api/js?key=AIzaSyAq5TPvce-Ornjbe71qIDVN7YsOWQjNVzk', this._onMap);
		},

		_onMap: function(){
			let markerLatLng = {
				lat: 56.927870,
				lng: 24.082226
			};
			this._bounds = new google.maps.LatLngBounds({
					lat: 56.925756,
					lng: 24.071862
				},
				{
					lat: 56.931570,
					lng: 24.109892
				});
			this._map = new google.maps.Map(this._mapNode, {
				center: window.innerWidth < 992 ? markerLatLng : this._bounds.getCenter(),
				zoom: 16,
				draggable: false,
				disableDefaultUI: true,
				styles: D.MAP_STYLE
			});
			this._marker = new google.maps.Marker({
				position: markerLatLng,
				icon: '/assets/images/marker.svg',
				map: this._map
			});
			if( window.innerWidth > 992 ){
				google.maps.event.addListener(this._map, 'idle', D.closure(this, function(){
					this._map.panToBounds(this._bounds, 0);
				}));
			}
		}
	},
	Section
);
SectionContacts.Form = Class(
	/**
	 * @lends {SectionContacts.Form#}
	 */
	{
		_inputs: {},

		__construct: function(type){
			if (!type) {
				type = 'contacts';
			}
			this.type = type;
			this.node = mkE({
				tag: 'div',
				className: 'contact-form',
				els: [
					{
						tag: 'h2',
						text: D.Lang.get('contacts.form.title')
					}
				]
			});
			this._drawForm();
			D.onCaptcha(this._onCaptcha);
		},

		_drawForm: function(){
			mkE({
				tag: 'form',
				onsubmit: this._submitForm,
				els: [
					{
						tag: 'div',
						className: 'row',
						els: [
							{
								tag: 'div',
								className: 'col col-50',
								els: [
									this._inputs.name = new T.Form.Input({
										caption: D.Lang.get('contacts.form.name')
									})
								]
							},
							{
								tag: 'div',
								className: 'col col-50',
								els: [
									this._inputs.email = new T.Form.Input({
										caption: D.Lang.get('contacts.form.email'),
										type: 'email'
									})
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'row',
						els: [
							{
								tag: 'div',
								className: 'col col-100',
								els: [
									this._inputs.message = new T.Form.TextArea({
										caption: D.Lang.get('contacts.form.message'),
										attr: {
											rows: 4
										}
									})
								]
							}
						]
					},
					this._captchaDiv = mkE({
						tag: 'div'
					}),
					this._button = mkE({
						tag: 'button',
						className: 'button button-pink button-large',
						text: D.Lang.get('contacts.form.submit')
					})
				]
			}).append(this.node);
		},

		_onCaptcha: function(){
			this._captcha = grecaptcha.render(
				this._captchaDiv,
				{
					sitekey: '6LdvnYEUAAAAADdoVoY8ZJp9lSLLl1gP_meCVUBD',
					theme: 'light',
					size: 'invisible',
					callback: this._submit
				}
			);
			mkE({
				tag: 'div',
				className: 'captcha-policy',
				els: [
					'This site is protected by reCAPTCHA and the Google ',
					{tag: 'a', href: 'https://policies.google.com/privacy', text: 'Privacy Policy', target: '_blank'},
					' and ',
					{tag: 'a', href: 'https://policies.google.com/terms', text: 'Terms of Service', target: '_blank'},
					' apply.'
				]
			}).append(this.node);
		},

		_submitForm() {
			grecaptcha.reset(this._captcha);
			grecaptcha.execute(this._captcha);
			return false;
		},

		_submit: function(){
			if( this._isSubmitting || this._isSubmitted ){
				return;
			}
			this._isSubmitting = true;
			new RPC('/api/web_rpc.php').send('submitContactForm', this._getData(), this._onSubmit);
			return false;
		},

		_getData: function(){
			return {
				name: this._inputs.name.value(),
				email: this._inputs.email.value(),
				message: this._inputs.message.value()
			};
		},

		_onSubmit: function(re){
			this._isSubmitting = false;
			for( let i in this._inputs ){
				if( this._inputs.hasOwnProperty(i) ){
					this._inputs[i].error(null);
				}
			}
			if( re.errors ){
				this._onError(re);
				return;
			} else if( re.ok ){
				this._onSent();
			}
			this._isSubmitted = true;
		},

		_onError: function(re){
			for( let i in re.errors ){
				if( re.errors.hasOwnProperty(i) ){
					this._inputs[i].error(D.Lang.get('contacts.form.errors.' + i));
				}
			}
		},

		_onSent: function(){
			if (this._inputs.how) {
				this._inputs.how.success(mkE({
					tag: 'span',
					innerHTML: D.Lang.get('contacts.form.ok')
				}));
			} else {
				this._inputs.message.success(mkE({
					tag: 'span',
					innerHTML: D.Lang.get('contacts.form.ok')
				}));
			}
			for( let i in this._inputs ){
				if( this._inputs.hasOwnProperty(i) ){
					const input = this._inputs[i];
					if( input instanceof T.Form.Phone ){
						input.value('371', '');
					} else{
						input.value('');
					}
				}
			}
			if (window.ga) {
				ga('send', {
					hitType: 'event',
					eventCategory: 'Form',
					eventAction: 'Submit',
					eventLabel: this.type
				});
			}
			const get = new Get();
			get.add('send-success', '');
			Section.replaceUrl(get.toUrl());
		}
	},
	mkE.Base
);

/**
 * @class
 * @param {SectionContacts.Form.Organize.Par} par
 * @extends SectionContacts.Form
 */
SectionContacts.Form.Organize = Class(
	/**
	 * @lends {SectionContacts.Form.Organize#}
	 */
	{
		_drawForm: function(){
			let durationOptions = [];
			let durationOptionsCount = Number(D.Lang.get('contacts.form.organize_duration_options.count') || 0);
			for (let i = 0; i < durationOptionsCount; i++) {
				durationOptions.push(D.Lang.get('contacts.form.organize_duration_options.count.' + i));
			}
			mkE({
				tag: 'form',
				onsubmit: function(){
					return false;
				},
				els: [
					{
						tag: 'div',
						className: 'row',
						els: [
							{
								tag: 'div',
								className: 'col col-50',
								els: [
									this._inputs.name = new T.Form.Input({
										caption: D.Lang.get('contacts.form.name')
									})
								]
							},
							{
								tag: 'div',
								className: 'col col-50',
								els: [
									this._inputs.email = new T.Form.Input({
										caption: D.Lang.get('contacts.form.email'),
										type: 'email'
									})
								]
							}
						]
					},
					{
						tag: 'div',
						els: [
							{
								tag: 'div',
								className: 'row',
								els: [
									{
										tag: 'div',
										className: 'col col-50',
										els: [
											this._inputs.phone = new T.Form.Phone({
												caption: D.Lang.get('contacts.form.phone'),
												code: '371'
											})
										]
									}
								]
							},
							{
								tag: 'div',
								className: 'row',
								els: [
									{
										tag: 'div',
										className: 'col col-33',
										els: [
											this._inputs.organize_participants = new T.Form.Input({
												type: 'number',
												caption: D.Lang.get('contacts.form.organize_participants'),
												value: 25,
												attr: {
													min: 25,
													step: 5
												}
											})
										]
									},
									{
										tag: 'div',
										className: 'col col-33',
										els: [
											this._inputs.organize_date = new T.Form.Input({
												caption: D.Lang.get('contacts.form.organize_date'),
												onFocus: function(){
													if( !this.datepicker ){
														this.datepickerContainer = mkE({
															tag: 'div',
															className: 'datePickerContainer',
															els: [
																{
																	tag: 'div',
																	className: 'datePickerContainerOverlay',
																	onclick: D.closure(this, function(){
																		this.datepickerContainer.remove();
																	})
																},
																this.datepicker = new T.DatePicker(
																	new T.DatePicker.Par()
																		.setOnchange(D.closure(this, function(){
																			this.value(this.datepicker.value());
																			this.datepickerContainer.remove();
																		}))
																		.setDisableBefore(TIME)
																)
															]
														})
													}
													this.datepickerContainer.append(this.node);
												}
											})
										]
									},
									{
										tag: 'div',
										className: 'col col-33',
										els: [
											this._inputs.organize_duration = new T.Form.Select({
												caption: D.Lang.get('contacts.form.organize_duration'),
												value: D.Lang.get('contacts.form.organize_duration_options.0'),
												options: function(){
													const options = durationOptions;
													let re = [];
													for( let i = 0; i < options.length; i++ ){
														const option = options[i];
														re.push({value: option, caption: option});
													}
													return re;
												}()
											})
										]
									}
								]
							},
							{
								tag: 'div',
								className: 'row',
								els: [
									{
										tag: 'div',
										className: 'col col-100',
										els: [
											this._inputs.organize_location = new T.Form.Input({
												caption: D.Lang.get('contacts.form.organize_location')
											})
										]
									}
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'row',
						els: [
							{
								tag: 'div',
								className: 'col col-100',
								els: [
									this._inputs.message = new T.Form.TextArea({
										caption: D.Lang.get('contacts.form.message'),
										attr: {
											rows: 4
										}
									})
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'row',
						els: [
							{
								tag: 'div',
								className: 'col col-100',
								els: [
									this._inputs.how = new T.Form.Select({
										caption: D.Lang.get('contacts.form.how'),
										options: function() {
											let options = [
												{
													value: '',
													caption: ''
												}
											];
											['google', 'social', 'friends', 'participant', 'other'].forEach(option => {
												options.push({
													value: option,
													caption: D.Lang.get('contacts.form.howSelect.' + option)
												})
											});
											return options;
										}(),
										onChange: () => {
											if (this._inputs.how.value() === 'other') {
												this._howText.style.display = '';
											} else {
												this._howText.style.display = 'none';
											}
										}
									})
								]
							}
						]
					},
					this._howText = mkE({
						tag: 'div',
						className: 'row',
						els: [
							{
								tag: 'div',
								className: 'col col-100',
								els: [
									this._inputs.howText = new T.Form.TextArea({
										attr: {
											rows: 2
										}
									})
								]
							}
						],
						style: {
							display: 'none'
						}
					}),
					this._button = mkE({
						tag: 'button',
						className: 'button button-pink button-large',
						text: D.Lang.get('contacts.form.submit')
					})
				]
			}).append(this.node);
		},

		_getData: function(){
			const phone = this._inputs.phone.value();
			return {
				from: 'corporate',
				name: this._inputs.name.value(),
				email: this._inputs.email.value(),
				message: this._inputs.message.value(),
				extra: {
					phone: phone && phone.value ? ((phone.code ? '+' + phone.code : '') + phone.value) : '',
					organize_participants: this._inputs.organize_participants.value(),
					organize_date: this._inputs.organize_date.value(),
					organize_duration: this._inputs.organize_duration.value(),
					organize_location: this._inputs.organize_location.value(),
					how: this._inputs.how.value(),
					howText: this._inputs.howText.value()
				}
			};
		}
	},
	SectionContacts.Form
);
